import produce from 'immer'

import {
  HOME_RECORDS_COUNT_LOAD,
  HOME_RECORDS_COUNT_LOAD_FAILURE,
  HOME_RECORDS_COUNT_LOAD_SUCCESS,
  HOME_ENABLED_ALERT_RULES_COUNT_LOAD,
  HOME_ENABLED_ALERT_RULES_COUNT_LOAD_FAILURE,
  HOME_ENABLED_ALERT_RULES_COUNT_LOAD_SUCCESS,
  HOME_ALERTS_SUMMARY_LOAD,
  HOME_ALERTS_SUMMARY_LOAD_FAILURE,
  HOME_ALERTS_SUMMARY_LOAD_SUCCESS
} from './actions'

const DEFAULT_TIME_PERIOD_STATE = {
  loading: false,
  error: null,
  count: null
}

const DEFAULT_MODULE_STATE = {
  total: DEFAULT_TIME_PERIOD_STATE,
  today: DEFAULT_TIME_PERIOD_STATE,
  last30Days: DEFAULT_TIME_PERIOD_STATE,
  assignedToMe: DEFAULT_TIME_PERIOD_STATE
}

const DEFAULT_ENABLED_ALERT_RULE_COUNT_STATE = {
  loading: false,
  error: null,
  count: null
}

const DEFAULT_ALERTS_SUMMARY_DATE_STATE = {
  activeMaterialCertifications: null,
  activeQualityAssurance: null,
  activeSubmissionIssues: null,
  activeTotal: null,
  activeWasteCompliance: null,
  mostFrequent: [],
  recentAlertsOverTime: {
    materialCertifications: [],
    qualityAssurance: [],
    submissionIssues: [],
    timePeriods: [],
    wasteCompliance: []
  }
}
const DEFAULT_ALERTS_SUMMARY_STATE = {
  loading: false,
  error: null,
  data: DEFAULT_ALERTS_SUMMARY_DATE_STATE
}

const DEFAULT_ALERTS_STATE = {
  enabledAlertRulesCount: DEFAULT_ENABLED_ALERT_RULE_COUNT_STATE,
  alertsSummary: DEFAULT_ALERTS_SUMMARY_STATE
}

const initialState = {
  waste: DEFAULT_MODULE_STATE,
  delivery: DEFAULT_MODULE_STATE,
  alerts: DEFAULT_ALERTS_STATE
}

const reducer = (state = initialState, action) => {
  let { moduleName } = action
  const { period } = action
  if (moduleName) {
    moduleName = moduleName.toLowerCase()
  }
  return produce(state, draft => {
    switch (action.type) {
      case HOME_RECORDS_COUNT_LOAD: {
        draft[moduleName][period].loading = true
        return
      }
      case HOME_RECORDS_COUNT_LOAD_SUCCESS: {
        draft[moduleName][period].loading = false
        draft[moduleName][period].error = null
        draft[moduleName][period].count = action.recordsCount.total
        return
      }
      case HOME_RECORDS_COUNT_LOAD_FAILURE: {
        draft[moduleName][period].loading = false
        draft[moduleName][period].error = action.error
        return
      }
      case HOME_ENABLED_ALERT_RULES_COUNT_LOAD: {
        draft.alerts.enabledAlertRulesCount.loading = true
        return
      }
      case HOME_ENABLED_ALERT_RULES_COUNT_LOAD_SUCCESS: {
        draft.alerts.enabledAlertRulesCount.loading = false
        draft.alerts.enabledAlertRulesCount.error = null
        draft.alerts.enabledAlertRulesCount.count = action.recordsCount
        return
      }
      case HOME_ENABLED_ALERT_RULES_COUNT_LOAD_FAILURE: {
        draft.alerts.enabledAlertRulesCount.loading = false
        draft.alerts.enabledAlertRulesCount.error = action.error
        return
      }
      case HOME_ALERTS_SUMMARY_LOAD: {
        draft.alerts.alertsSummary.loading = true
        return
      }
      case HOME_ALERTS_SUMMARY_LOAD_SUCCESS: {
        draft.alerts.alertsSummary.loading = false
        draft.alerts.alertsSummary.error = null
        draft.alerts.alertsSummary.data = action.recordsCount
        return
      }
      case HOME_ALERTS_SUMMARY_LOAD_FAILURE: {
        draft.alerts.alertsSummary.loading = false
        draft.alerts.alertsSummary.error = action.error
        return
      }
    }
  })
}

export { reducer }
